import { SVGProps } from '@components/Icon/types';

export const Dragndrop = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(7, 3)">
      <path
        d="M0 16.0714C0 17.1321 0.880435 18 1.95652 18C3.03261 18 3.91304 17.1321 3.91304 16.0714C3.91304 15.0107 3.03261 14.1429 1.95652 14.1429C0.880435 14.1429 0 15.0107 0 16.0714Z"
        fill={fill}
      />
      <path
        d="M0 9C0 10.0607 0.880435 10.9286 1.95652 10.9286C3.03261 10.9286 3.91304 10.0607 3.91304 9C3.91304 7.93929 3.03261 7.07143 1.95652 7.07143C0.880435 7.07143 0 7.93929 0 9Z"
        fill={fill}
      />
      <path
        d="M0 1.92857C0 2.98929 0.880435 3.85714 1.95652 3.85714C3.03261 3.85714 3.91304 2.98929 3.91304 1.92857C3.91304 0.867857 3.03261 0 1.95652 0C0.880435 0 0 0.867857 0 1.92857Z"
        fill={fill}
      />
      <path
        d="M6.08696 16.0714C6.08696 17.1321 6.96739 18 8.04348 18C9.11956 18 10 17.1321 10 16.0714C10 15.0107 9.11956 14.1429 8.04348 14.1429C6.96739 14.1429 6.08696 15.0107 6.08696 16.0714Z"
        fill={fill}
      />
      <path
        d="M6.08696 9C6.08696 10.0607 6.96739 10.9286 8.04348 10.9286C9.11956 10.9286 10 10.0607 10 9C10 7.93929 9.11956 7.07143 8.04348 7.07143C6.96739 7.07143 6.08696 7.93929 6.08696 9Z"
        fill={fill}
      />
      <path
        d="M6.08696 1.92857C6.08696 2.98929 6.96739 3.85714 8.04348 3.85714C9.11956 3.85714 10 2.98929 10 1.92857C10 0.867857 9.11956 0 8.04348 0C6.96739 0 6.08696 0.867857 6.08696 1.92857Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'dragndrop';
